export enum DeviceHealthRecordType { 
    None = 0,
    BadSatFix = 1,
    MessageSpam = 2,
    MissingOdometer = 3,
    LocationSnapped = 4,
    CameraVideoLoss = 5,
    CameraMemoryFault = 6,
    CameraStorageFailure = 7,
    CameraLowVoltage = 8,
    CameraPowerLoss = 9,
    CameraGPSLoss = 10
}